import { render, staticRenderFns } from "./ModelListAndEdition.vue?vue&type=template&id=48a20374"
import script from "./ModelListAndEdition.vue?vue&type=script&lang=ts"
export * from "./ModelListAndEdition.vue?vue&type=script&lang=ts"
import style0 from "./ModelListAndEdition.vue?vue&type=style&index=0&id=48a20374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModelListAndEdition.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports